import { render, staticRenderFns } from "./editTpl.vue?vue&type=template&id=39f1b27c&scoped=true"
import script from "./editTpl.vue?vue&type=script&lang=js"
export * from "./editTpl.vue?vue&type=script&lang=js"
import style0 from "./editTpl.vue?vue&type=style&index=0&id=39f1b27c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1b27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f1b27c')) {
      api.createRecord('39f1b27c', component.options)
    } else {
      api.reload('39f1b27c', component.options)
    }
    module.hot.accept("./editTpl.vue?vue&type=template&id=39f1b27c&scoped=true", function () {
      api.rerender('39f1b27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printRelated/copyOrders/editTpl.vue"
export default component.exports